<template>
  <div class="personalDetail">
    <div class="content-box">
      <h2>自考乐【应用描述】</h2>
      <p style="font-size: 14px">
        自考乐学习平台专注高校成人教育的移动应用，服务各大高职院校，提供从学习到考试、到学分认证，证书颁发的完整教学流程服务。平台提倡系统化的学习，旨在帮助用户获得全面、体系的知识和技能，实现学有所长，并能学以致用。
      </p>
      <p>
        自考乐专注服务自考助学人群，各位学子可通过自考乐学习自考助学院校的相关课程。一站解决自考听课学习、押题刷题和考试三大需求，帮助考生顺利高分通过自学考试。
      </p>
      <h2 class="mat40">【特色功能】</h2>
      <strong>【课程学习】</strong
      ><br />提供多种类型精品课程，自考学习知识点全覆盖。<br />高校教授、资深讲师授课、在线答疑，带您全面学习，提高学习效率，快速掌握重点、难点知识。<br /><strong
        >【试题练习】</strong
      ><br />针对每章节的知识点出题，帮助学生更快掌握知识点。<br /><strong
        >【试卷练习】</strong
      ><br />历年真题、模拟考试、单元测试等等试卷，及时测试知识掌握情况。<br /><strong
        >【智能练习】</strong
      ><br />海量题库，针对题型攻克，还可查看自己在学生中的排名，便于碎片时间的快速练习。<br /><strong
        >【学习记录】</strong
      ><br />记录您的错题记录，形成错题集再次练习，还可对知识点做笔记、收藏难题、重点题，全面检测自己的不足之处，再进行针对性的训练。
      <span style="font-size: 14px"></span>
    </div>

    <img
      src="../../assets/images/个人中心图.png"
      class="personalDetail-background"
    />
  </div>
</template>

<script>
export default {
  name: "index",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.personalDetail {
  padding: 20px;
  background: #ffffff;
  position: relative;
  height: 100%;

  .personalDetail-background {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .content-box {
    width: 1000px;
    margin-top: 100px;
    margin: 100px auto 0;

    h2 {
      font-weight: bold;
    }
  }

  .personalDetail-info {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);

    .personalDetail-info-headPortrait {
      width: 150px;
      height: 150px;

      span {
        display: block;
        width: 150px;
        height: 150px;
        /*border: 2px solid #999999;*/
        border-radius: 50%;
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);

        .el-image {
          width: 150px;
          height: 150px;
          border-radius: 50%;
        }

        .el-icon-camera-solid {
          position: absolute;
          right: 5%;
          bottom: 5%;
          font-size: 20px;
          color: #ffffff;
          width: 30px;
          height: 30px;
          line-height: 30px;
          border-radius: 50%;
          background-color: #e5472c;
        }

        img {
          height: 100%;
          width: 100%;
          border-radius: 50%;
          display: block;
        }
      }
    }

    .personalDetail-username {
      text-align: center;
      margin: 10px 0;
      @include fontColor("primary");
    }

    /*信息数据列表*/
    .personalDetail-info-list {
      width: 900px;
      /*border: 1px solid #cccccc;*/
      display: flex;

      ul {
        width: 100%;

        li {
          width: 50%;
          float: left;
          padding-right: 5%;
          height: 100px;

          div {
            border-bottom: 1px solid #cccccc;
            display: flex;
            height: 100px;
            align-items: center;

            p {
              display: flex;
              width: 100%;
              padding: 20px 0;
            }

            .span {
              min-width: 80px;
              display: block;
              font-weight: 700;
              text-align: center;
            }

            .em {
              display: block;
              flex: 7;
              color: #666666;

              a:hover {
                color: #666666 !important;
              }

              ins {
                display: block;
                text-decoration: none;
              }

              i {
                float: right;
                font-size: 18px;
                cursor: pointer;
              }
            }

            .el-button {
              padding: 0;
            }
          }
        }
      }
    }
  }
}
</style>
